export const calculateVisibleLabelsCount = ({ labels, containerRef }) => {
  if (!containerRef.current) {
    return labels.length;
  }

  const containerRect = containerRef.current.getBoundingClientRect();

  const children = [...containerRef.current.children];

  let count = 0;
  for (const child of children) {
    const childRect = child.getBoundingClientRect();

    // check if child is in the first row
    if (childRect.top === containerRect.top) {
      count++;
    }
  }

  return count;
};

/**
 * Returns all unique labels applied to sources
 * @param {Insight} insight
 * @returns {Labeled[]} labels
 */
export const getInsightLabels = (insight) => {
  const labelsMap = new Map();
  insight?.cards?.forEach((card) => {
    card?.labels?.forEach((label) => {
      if (!labelsMap.has(label.id)) {
        labelsMap.set(label.id, label);
      }
    });
  });

  return [...labelsMap.values()];
};
